var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Appointments",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.004,
    height: 20,
    viewBox: "0 0 20.004 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13122",
    "data-name": "Path 13122",
    d: "M122.146,45.492v-6.2A2.146,2.146,0,0,0,120,37.144h-1.429v-.357a1.786,1.786,0,0,0-3.572,0v.357h-2.858v-.357a1.786,1.786,0,0,0-3.572,0v.357h-1.429A2.146,2.146,0,0,0,105,39.287V52.146a2.146,2.146,0,0,0,2.143,2.143h10.3a4.995,4.995,0,1,0,4.706-8.8Zm-5.715-8.705a.357.357,0,1,1,.714,0V38.93a.357.357,0,1,1-.714,0Zm-6.43,0a.357.357,0,1,1,.714,0V38.93a.357.357,0,1,1-.714,0Zm-2.858,1.786h1.429v.357a1.786,1.786,0,0,0,3.572,0v-.357H115v.357a1.786,1.786,0,0,0,3.572,0v-.357H120a.715.715,0,0,1,.714.714V41.43H106.429V39.287a.715.715,0,0,1,.714-.714Zm-.714,13.574V42.859h14.288v2.2a4.991,4.991,0,0,0-4.812,7.8h-8.761a.715.715,0,0,1-.714-.714ZM120,53.575a3.576,3.576,0,1,1,2.524-1.048A3.572,3.572,0,0,1,120,53.575Z",
    transform: "translate(-105 -35.001)",
    fill: "#bebfb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13123",
    "data-name": "Path 13123",
    d: "M457.143,334.643h-.714v-1.429a.714.714,0,1,0-1.429,0v2.143a.714.714,0,0,0,.714.714h1.429a.714.714,0,1,0,0-1.429Z",
    transform: "translate(-440.712 -320.355)",
    fill: "#bebfb6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/Appointments.cea0df57df23dd15306cb72ed635a483.svg";
export { ForwardRef as ReactComponent };